import { z } from 'zod';

export const LayoutServerSecretsSchema = z.object({
  webhooks: z.record(z.object({
    url: z.string().url(),
    method: z.string(),
    headers: z.record(z.string())
  })),
  answer_keys: z.record(z.unknown()).optional()
});
export type LayoutServerSecrets = z.infer<typeof LayoutServerSecretsSchema>;